import { BaseMultiText } from '../../../translation';
import { currentBuilderState } from '../builder.state';
import { MAX_SELECTABLE_METRICS } from '../const/max-selectable-metrics.const';

export function checkCacheMetricParams(): void {
    const state = currentBuilderState();
    const vp = state.viewParams;

    if (vp.metrics != null) {
        const next: BaseMultiText[] = [];
        vp.metrics.forEach((m) => {
            const mm = state.metrics?.find((e) => e.id === m.id);
            if (mm != null) {
                next.push(mm);
            }
        });
        vp.metrics = next;
    }

    state.cannotSelectMetrics = vp.metrics?.length >= MAX_SELECTABLE_METRICS;
}
